import {
  DARK_COLORS,
  LIGHT_COLORS,
} from "../../../styleguide/onboarding/components/ui/color-pair/templates/colors";

export const getOwnColors = ({ ownColors }) => {
  if (!ownColors) return undefined;

  const colors = ownColors.light.map((lightColor) => {
    const darkColor = ownColors.dark.find(
      (darkColor) => darkColor.id === lightColor.id
    );
    return {
      accent: {
        light: lightColor.accent || "#FFFFFF",
        dark: darkColor.accent || "#000000",
      },
      text: {
        light: lightColor.text || "#000000",
        dark: darkColor.text || "#FFFFFF",
      },
    };
  });

  return colors;
};

export const getOpticsColors = () => {
  const colors = LIGHT_COLORS.map((lightColor) => {
    const darkColor = DARK_COLORS.find(
      (darkColor) => darkColor.id === lightColor.id
    );
    return {
      accent: {
        light: lightColor.accent || "#FFFFFF",
        dark: darkColor.accent || "#000000",
      },
      text: {
        light: lightColor.text || "#000000",
        dark: darkColor.text || "#FFFFFF",
      },
    };
  });

  return colors;
};
